(() => {
  if (window.__dblClarityConsentBridge) return;
  window.__dblClarityConsentBridge = true;

  let activeAttempt = null;
  let lastPair = null;
  let loaderStarted = false;

  const privacyReady = () => {
    const privacy = window.Shopify?.customerPrivacy;
    return privacy && typeof privacy.analyticsProcessingAllowed === 'function' &&
      typeof privacy.marketingAllowed === 'function';
  };

  const applyCurrentPermissions = () => {
    const privacy = window.Shopify.customerPrivacy;
    const analytics = privacy.analyticsProcessingAllowed();
    const marketing = privacy.marketingAllowed();
    if (typeof analytics !== 'boolean' || typeof marketing !== 'boolean') return;

    const pair = `${analytics}:${marketing}`;
    if (pair === lastPair) return;

    const existingLoader = document.querySelector('script[src*="clarity.ms/tag/"]');
    const runningInstance = typeof window.clarity === 'function' && !window.clarity.q;
    window.clarity = window.clarity || function () {
      (window.clarity.q = window.clarity.q || []).push(arguments);
    };
    if (typeof window.clarity !== 'function') return;

    window.clarity('consentv2', {
      analytics_Storage: analytics ? 'granted' : 'denied',
      ad_Storage: marketing ? 'granted' : 'denied',
    });
    lastPair = pair;

    if (loaderStarted || existingLoader || runningInstance) return;
    loaderStarted = true;
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.clarity.ms/tag/p0jyfmt2q4';
    document.head.appendChild(script);
  };

  const finishAttempt = (attempt, error) => {
    if (activeAttempt !== attempt) return;
    activeAttempt = null;
    clearTimeout(attempt.deadline);
    clearTimeout(attempt.poll);
    if (error || Date.now() >= attempt.expires || !privacyReady()) return;
    try {
      applyCurrentPermissions();
    } catch {
      return;
    }
  };

  const sync = () => {
    if (privacyReady()) {
      if (activeAttempt) {
        clearTimeout(activeAttempt.deadline);
        clearTimeout(activeAttempt.poll);
        activeAttempt = null;
      }
      try {
        applyCurrentPermissions();
      } catch {
        return;
      }
      return;
    }
    if (activeAttempt) return;

    const attempt = { expires: Date.now() + 5000 };
    activeAttempt = attempt;
    attempt.deadline = setTimeout(() => finishAttempt(attempt, true), 5000);

    const awaitBootstrap = () => {
      if (activeAttempt !== attempt) return;
      if (Date.now() >= attempt.expires) {
        finishAttempt(attempt, true);
        return;
      }
      if (typeof window.Shopify?.loadFeatures !== 'function') {
        attempt.poll = setTimeout(awaitBootstrap, 50);
        return;
      }
      try {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }],
          error => finishAttempt(attempt, error));
      } catch {
        finishAttempt(attempt, true);
      }
    };
    awaitBootstrap();
  };

  document.addEventListener('visitorConsentCollected', sync);
  sync();
})();
